import React from 'react';
import { motion } from 'framer-motion';
import { Check, Target } from 'lucide-react';
const isForYou = ['Trabajás o querés trabajar con deportistas con discapacidad y sentís que te falta una estructura específica.', 'Ya tenés herramientas de psicología deportiva, pero no siempre sabés cómo adaptarlas al deporte adaptado.', 'Te cuesta saber cómo preguntar por la discapacidad sin sonar invasivo ni evitar el tema por incomodidad.', 'Querés trabajar rendimiento sin caer en lástima, sobreprotección o frases vacías de superación.', 'Querés sentir más seguridad profesional al intervenir con deportistas, familias, entrenadores y cuerpo técnico.'];
const results = ['Entrás a sesión con más claridad.', 'Evaluás sin reducir al deportista a su discapacidad.', 'Diseñás planes de trabajo mental adaptados al deporte, nivel competitivo y contexto real.', 'Preparás al deportista para competir con más recursos psicológicos.', 'Trabajás con más seguridad, respeto, orden y autoridad profesional.'];
export function TargetAudience() {
  return <section className="py-20 bg-white" data-id="element-172">
      <div className="container px-4 mx-auto max-w-5xl" data-id="element-173">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-174">
          {/* Is for you */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-175">
            <h2 className="text-2xl md:text-3xl font-black text-[#0c3b42] mb-8 uppercase flex items-center gap-3" data-id="element-176">
              <Target className="w-8 h-8 text-[#f97316]" data-id="element-177" />
              ESTE KIT ES PARA VOS SI...
            </h2>
            <div className="space-y-6" data-id="element-178">
              {isForYou.map((item, idx) => <div key={idx} className="flex items-start gap-4 bg-slate-50 p-4 rounded-xl border border-slate-100" data-id="element-179">
                  <div className="w-6 h-6 rounded-full bg-[#f97316] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-180">
                    <Check className="w-4 h-4 text-white" data-id="element-181" />
                  </div>
                  <p className="text-slate-700 font-medium leading-relaxed" data-id="element-182">
                    {item}
                  </p>
                </div>)}
            </div>
          </motion.div>

          {/* Results */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#0c3b42] rounded-3xl p-8 md:p-10 text-white shadow-xl" data-id="element-183">
            <h2 className="text-2xl md:text-3xl font-black text-[#7fd1c9] mb-8 uppercase" data-id="element-184">
              EL RESULTADO
            </h2>
            <div className="space-y-6" data-id="element-185">
              {results.map((item, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-186">
                  <div className="w-6 h-6 rounded-full bg-[#16a34a] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-187">
                    <Check className="w-4 h-4 text-white" data-id="element-188" />
                  </div>
                  <p className="text-slate-200 font-medium leading-relaxed text-lg" data-id="element-189">
                    {item}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}